import WebStorageCache from 'web-storage-cache'

type CacheType = 'sessionStorage' | 'localStorage'

// 공용 캐시 생성 함수
export const createCache = (type: CacheType = 'localStorage') => {
  return new WebStorageCache({ storage: type })
}

// 단일 인스턴스 캐시 (전역 재사용)
export const cache = createCache('localStorage')
export const sessionCache = createCache('sessionStorage')

/*
export const useCache = (type: CacheType = 'localStorage') => {
  const wsCache: WebStorageCache = new WebStorageCache({
    storage: type,
  })

  return wsCache
}

export const useSessionCache = (type: CacheType = 'sessionStorage') => {
  const wsCache: WebStorageCache = new WebStorageCache({
    storage: type,
  })

  return wsCache
}
*/
